import React, { useState } from "react";
import ItemLedgerTopTable from "../../../components/Tables/ItemLedgerTopTable";
import ItemLedgerBottomTable from "../../../components/Tables/ItemLedgerBottomTable";
import { FaChevronCircleDown, FaChevronCircleUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isGuestInvoice } from "../../../utils/invoice";
import EditCustomerPageModal from "../../../components/Modals/EditCustomerPageModal";
import RowActionsMenu from "../../../components/RowActionsMenu/RowActionsMenu";
import { updateCustomerPageNoInReport } from "../../../store/Slices/ReportSlice";

const getAppBasePath = () =>
  Number(localStorage.getItem("role")) === 1 ? "/admin" : "/branch";

const TransactionReportItem = ({
  trans,
  type = 1,
  editable = false,
  onPageUpdated,
}) => {
  const [OpenDetails, setOpenDetails] = useState(false);
  const [pageModalOpen, setPageModalOpen] = useState(false);
  const [pageNoOverride, setPageNoOverride] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const customer =
    trans?.customerId && typeof trans.customerId === "object"
      ? trans.customerId
      : null;
  const customerForModal = customer ? { ...customer } : null;
  const canEditPage = Boolean(customer?._id) && !isGuestInvoice(trans);
  const showActions = Boolean(trans?._id);
  // Redux/Immer report rows are frozen — display page via a shallow copy
  const displayTrans =
    pageNoOverride == null || !customer
      ? trans
      : {
          ...trans,
          customerId: { ...customer, page_no: pageNoOverride },
        };

  const goToEditInvoice = () => {
    if (!trans?._id) return;
    navigate(`${getAppBasePath()}/edit-customers-invoice/${trans._id}`);
  };

  const goToPrintInvoice = () => {
    if (!trans?._id) return;
    const cid =
      customer?._id ||
      (typeof trans.customerId === "string" ? trans.customerId : "") ||
      "guest";
    navigate(`${getAppBasePath()}/invoice/${trans._id}/${cid}`);
  };

  return (
    <div className="flex flex-col mb-3">
      <div className="flex items-center bg-gradient-to-r from-main to-mainHover border border-sec2/40 px-3 sm:px-4 gap-x-2 overflow-x-auto rounded-xl shadow-soft">
        <div className="flex-1 min-w-0">
          <ItemLedgerTopTable Data={displayTrans} type={type} />
        </div>
        {showActions && (
          <div className="shrink-0">
            <RowActionsMenu
              row={trans}
              iconColor="#ffffff"
              onPrint={goToPrintInvoice}
              onEdit={editable ? goToEditInvoice : undefined}
              onEditPage={canEditPage ? () => setPageModalOpen(true) : undefined}
            />
          </div>
        )}
        {OpenDetails === false ? (
          <FaChevronCircleDown
            className="text-white text-xl shrink-0 cursor-pointer opacity-90 hover:opacity-100"
            onClick={() => {
              setOpenDetails(true);
            }}
          />
        ) : (
          <FaChevronCircleUp
            className="text-white text-xl shrink-0 cursor-pointer opacity-90 hover:opacity-100"
            onClick={() => {
              setOpenDetails(false);
            }}
          />
        )}
      </div>
      {OpenDetails && (
        <div className="w-[99.3%] mx-auto">
          <ItemLedgerBottomTable Data={displayTrans} />
        </div>
      )}
      {canEditPage && (
        <EditCustomerPageModal
          Open={pageModalOpen}
          setOpen={setPageModalOpen}
          customer={customerForModal}
          onSuccess={(nextPage) => {
            setPageNoOverride(nextPage);
            if (customer?._id) {
              dispatch(
                updateCustomerPageNoInReport({
                  customerId: customer._id,
                  page_no: nextPage,
                })
              );
            }
            if (typeof onPageUpdated === "function") {
              onPageUpdated(trans, nextPage);
            }
          }}
        />
      )}
    </div>
  );
};

export default TransactionReportItem;
